module.exports = __webpack_public_path__ + "static/media/passport.5ed58464.png";